<div class="ao-overview">
  <div>
    <div class="paragraph-large-medium">Conflict of Interest Advisory</div>
    <div class="coi-2nd-header paragraph-medium-medium">Definition of Interest</div>
    <div class="paragraph-medium-regular">{{ coi[0].value }}</div>
    <div class="paragraph-medium-regular">{{ coi[1].value }}</div>
    <div class="paragraph-medium-regular">{{ coi[2].value }}</div>
    <div class="paragraph-medium-regular">{{ coi[3].value }}</div>
    <div class="coi-2nd-header paragraph-medium-medium">Warning</div>
    <div class="paragraph-medium-regular">{{ coi[4].value }}</div>
  </div>

  <mat-divider class="divider-gap"></mat-divider>

  <div class="purchase-details">
    <div class="header heading-h6-regular">Purchase details</div>
    <div *ngIf="this.isDisplayGEWCA()" style="padding-right:35px;">
      <shared-alert [type]="alertType.Info">
        <p alert-content class="my-1">This is a Guns, Explosives and Weapons Control Act (GEWCA) related purchase.</p>
      </shared-alert>
    </div>
    <div class="content-table">
      <div class="title paragraph-medium-regular">Document no:</div>
      <div class="doc-no link paragraph-medium-regular"
        (keypress)="navigateToRO(this.ApprovingOfficerSummary.MPDocumentNumber,this.ApprovingOfficerSummary.purchaseType )"
        (click)="navigateToRO(this.ApprovingOfficerSummary.MPDocumentNumber,this.ApprovingOfficerSummary.purchaseType )">{{this.ApprovingOfficerSummary.MPDocumentNumber}}
      </div>
      <div class="title paragraph-medium-regular">Purchase mode:</div>
      <div class="content paragraph-medium-regular">
        {{ displayPurchaseMode(this.ApprovingOfficerSummary.purchaseType) }}
      </div>
      <div class="title paragraph-medium-regular">Workflow:</div>
      <div class="content paragraph-medium-regular">
        {{ purchaseDetails.process }}
      </div>
      <ng-container *ngIf="purchaseDetails.purchaseMode === PurchaseTypeEnum.PM">
        <div class="title paragraph-medium-regular">Permissible Reason:</div>
        <div class="content paragraph-medium-regular">
          {{ purchaseDetails.pemissibleReason }}
        </div>
        <!-- <div class="title">Workflow:</div>
        <div class="content">
          {{ purchaseDetails.process }}
        </div> -->
      </ng-container>
      <ng-container  *ngIf="purchaseDetails.purchaseMode === PurchaseTypeEnum.TENDER || purchaseDetails.purchaseMode === PurchaseTypeEnum.DC">
      <div class="title paragraph-medium-regular">Title of purchase:</div>
        <div class="content paragraph-medium-regular">
          <div class="long-text">
            {{ this.ApprovingOfficerSummary.PurchaseTitle }}
          </div>
        </div>
      </ng-container>
      <div class="title paragraph-medium-regular">Purpose of purchase:</div>
        <div class="content paragraph-medium-regular">
          <div class="long-text">
            {{ this.ApprovingOfficerSummary.Purpose }}
          </div>
        </div>
      </div>
  </div>

  <div class="budget-allocation">
    <mat-divider class="divider-gap"></mat-divider>
    <div class="header heading-h6-regular">Budget allocation</div>
    <p class="paragraph-medium-regular">The values listed in the table are denominated in Singapore dollars (SGD).</p>
    <div class="container header-project-completion-message paragraph-medium-regular" *ngIf="showProjectCompletionMessage">
      <div><mat-icon class="icon">info</mat-icon></div>
      <ng-container>
        <span>For the following budget/cost centre: {{budgetNames}}
          Please note that the project budget selected has only 25% of the project schedule left or 6 months remaining
          before completion. Kindly ensure that the purchase will be delivered in time for project use as it will be
          subjected to audit.
        </span>
      </ng-container>
    </div>
    <div class="paragraph-medium-regular fetching-hint" *ngIf="isLoadingSAPData && !issapTimeout"><img class="fetching-img"
        src="/assets/images/sql_fetching.svg" alt="fetching_In_Progress">Fetching SAP data, this may a take few minutes...</div>
    <div *ngIf="!isLoadingSAPData && issapTimeout" class="paragraph-medium-regular sap-error"><img class="fetching-img"
        src="/assets/images/error_fetching.svg" alt="error-fetching">Connection timeout, <a (click)="retrySAP()">please click here to try
        again</a>
    </div>
    <mat-progress-bar mode="indeterminate" *ngIf="isLoadingSAPData && !issapTimeout"></mat-progress-bar>
    <div class="table-wrapper" *ngIf="newDataSource.data.length > 0">
      <div class="scrollable-table">
        <table mat-table [dataSource]="newDataSource" multiTemplateDataRows class="mat-elevation-z3 content-table">
  
          <ng-container matColumnDef="budgetType">
            <th mat-header-cell *matHeaderCellDef>Budget type</th>
            <td mat-cell *matCellDef="let element">{{ element.budgetType }}</td>
          </ng-container>
  
          <ng-container matColumnDef="budgetCostCentre">
            <th mat-header-cell *matHeaderCellDef>Budget/Cost centre</th>
            <td mat-cell *matCellDef="let element">
              {{ budgetAllocationContent(element).budgetCostCenter }}
            </td>
          </ng-container>
  
          <ng-container matColumnDef="glAccount">
            <th mat-header-cell *matHeaderCellDef>G/L account</th>
            <td mat-cell *matCellDef="let element">{{ element.glAccount }}</td>
          </ng-container>
  
          <ng-container matColumnDef="orderNo">
            <th mat-header-cell *matHeaderCellDef>Order no.</th>
            <td mat-cell *matCellDef="let element">{{ element.orderNo }}</td>
          </ng-container>
  
          <ng-container matColumnDef="financialYear">
            <th mat-header-cell *matHeaderCellDef>Financial Year</th>
            <td mat-cell *matCellDef="let element">
              {{ element.FinancialYear }}
            </td>
          </ng-container>
  
          <ng-container matColumnDef="budgetAvailability">
            <th mat-header-cell *matHeaderCellDef>Budget availability</th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="!isLoadingSAPData; else skeleton">
                {{element.budgetAvailability}}
              </ng-container>
              <ng-template #skeleton>
                <div class="skeleton"></div>
              </ng-template>
            </td>
          </ng-container>
  
          <ng-container matColumnDef="totalAmount">
            <th mat-header-cell *matHeaderCellDef>AOR Amount</th>
            <td mat-cell *matCellDef="let element">{{ element.aorAmount - element.aorExemptedAmount | number: '1.2' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="AorExemptedAmount">
            <th mat-header-cell *matHeaderCellDef>AOR exempted amount</th>
            <td mat-cell *matCellDef="let element">{{ element.exemptedAmount ? (element.exemptedAmount | number: '1.2') :
              "-" }}</td>
          </ng-container>
          <ng-container matColumnDef="budgetBalance">
            <th mat-header-cell *matHeaderCellDef>Budget balance</th>
            <td mat-cell *matCellDef="let element" [ngClass]="fontTextColor(element.budgetBalance)">
              <ng-container *ngIf="!isLoadingSAPData; else skeleton">
                {{element.budgetBalance}}
              </ng-container>
              <ng-template #skeleton>
                <div class="skeleton"></div>
              </ng-template>
            </td>
          </ng-container>
  
          <ng-container matColumnDef="expenditureUsage">
          <th mat-header-cell *matHeaderCellDef>Expenditure Usage</th>
          <td mat-cell *matCellDef="let element">{{ budgetAllocationContent(element).expenditure}}</td>
        </ng-container>
        <ng-container matColumnDef="frequencyUsage">
          <th mat-header-cell *matHeaderCellDef>Frequency Usage</th>
          <td mat-cell *matCellDef="let element">{{ budgetAllocationContent(element).frequency}}</td>
        </ng-container>
        <ng-container matColumnDef="excoApproval">
          <th mat-header-cell *matHeaderCellDef>EXCO/Board's Approval</th>
          <td mat-cell *matCellDef="let element">{{ budgetAllocationContent(element).exco}}</td>
        </ng-container>
        <!-- <ng-container matColumnDef="spaceRequirements">
          <th mat-header-cell *matHeaderCellDef>Space Requirements</th>
          <td mat-cell *matCellDef="let element">{{ budgetAllocationContent(element).spaceReq}}</td>
        </ng-container> -->
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay" class="element-row"></tr>
      </table>
      </div>
      <mat-paginator #budgetPaginator [pageSize]="defaultPageSize" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons
        class="custom-table-paginator"></mat-paginator>
    </div>
    <div class="woc-content" *ngIf="currentWorkflow?.workflow_id == 'WOCApproval'">
      <span class="woc-title paragraph-medium-regular">Est. Total Amount:</span> {{ currentWorkflow.totalAmount | number: '1.2' }}
    </div>
  </div>

  <!-- item Requested Section -->

  <div class="items-section">
    <mat-divider class="divider-gap"></mat-divider>
    <div class="header heading-h6-regular">Items requested</div>
    <div class="items-table-wrapper">
      <table mat-table [dataSource]="itemsDataSource" multiTemplateDataRows class="mat-elevation-z3">

        <ng-container matColumnDef="ItemNo" sticky>
          <th mat-header-cell *matHeaderCellDef>Item no.</th>
          <td mat-cell *matCellDef="let element">{{ element.ItemNo }}</td>
        </ng-container>
        <ng-container matColumnDef="MatSubGrp">
          <th mat-header-cell *matHeaderCellDef>Material sub group</th>
          <td mat-cell *matCellDef="let element">{{ formatMaterialSubGroupId(element.MatSUbGrp) }}</td>
        </ng-container>
        <ng-container matColumnDef="ItemDesc">
          <th mat-header-cell *matHeaderCellDef>Item description</th>
          <td mat-cell *matCellDef="let element">{{ element.ItemDesc }}</td>
        </ng-container>
        <ng-container matColumnDef="PartNum">
          <th mat-header-cell *matHeaderCellDef>Part/model no.</th>
          <td mat-cell *matCellDef="let element">{{ element.PartNum }}</td>
        </ng-container>
        <ng-container matColumnDef="Qty">
          <th mat-header-cell *matHeaderCellDef>Qty</th>
          <td mat-cell *matCellDef="let element">{{ element.Qty }}</td>
        </ng-container>
        <ng-container matColumnDef="UoM">
          <th mat-header-cell *matHeaderCellDef>UoM</th>
          <td mat-cell *matCellDef="let element">{{ element.UoM }}</td>
        </ng-container>
        <ng-container matColumnDef="Currency">
          <th mat-header-cell *matHeaderCellDef>Currency</th>
          <td mat-cell *matCellDef="let element">{{ element.Currency }}</td>
        </ng-container>
        <ng-container matColumnDef="UnitPrice">
          <th mat-header-cell *matHeaderCellDef>Est. unit price</th>
          <td mat-cell *matCellDef="let element">{{ element.UnitPrice | number: '1.2' }}</td>
        </ng-container>
        <ng-container matColumnDef="itemAmount">
          <th mat-header-cell *matHeaderCellDef>Est. item amount</th>
          <td mat-cell *matCellDef="let element">{{ element.itemAmount | number: '1.2' }}</td>
        </ng-container>
        <ng-container matColumnDef="BudgetsInvolved">
          <th mat-header-cell *matHeaderCellDef> Budgets Involved </th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.BudgetsInvolved?.length">
              <ng-container *ngIf="isBudgetCellExpanded(element); else collapsedBudgetView">
                <div *ngFor="let group of element.BudgetsInvolved">
                  <div style="text-decoration: underline; font-weight: bold;">{{ group.type }}</div>
                  <ul style="margin-bottom: 0;">
                    <li>{{ group.centre }}</li>
                    <li>{{ group.gl }}</li>
                  </ul>
                </div>
              </ng-container>
        
              <ng-template #collapsedBudgetView>
                <div *ngFor="let group of element.BudgetsInvolved.slice(0, 2)">
                  <div style="text-decoration: underline; font-weight: bold;">{{ group.type }}</div>
                  <ul>
                    <li>{{ group.centre }}</li>
                    <li>{{ group.gl }}</li>
                  </ul>
                </div>
                <span *ngIf="element.BudgetsInvolved.length > 2">...</span>
              </ng-template>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="DistType">
          <th mat-header-cell *matHeaderCellDef>Distribution type</th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.BudgetsInvolved?.length">
              <ng-container *ngIf="isBudgetCellExpanded(element); else collapsedDistView">
                <div class="distribution-cell">
                  <div *ngFor="let group of element.BudgetsInvolved; let i = index">
                    {{ getDistributionType(element, i) }}
                  </div>
                </div>
              </ng-container>
          
              <ng-template #collapsedDistView>
                <div class="distribution-cell">
                  <div *ngFor="let group of element.BudgetsInvolved.slice(0, 2); let i = index">
                    {{ getDistributionType(element, i) }}
                  </div>
                </div>
                  <span *ngIf="element.BudgetsInvolved.length > 2">...</span>
              </ng-template>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="DistShare">
          <th mat-header-cell *matHeaderCellDef>Distribution share</th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.BudgetsInvolved?.length">
              <ng-container *ngIf="isBudgetCellExpanded(element); else collapsedDistView">
                <div class="distribution-cell">
                <div *ngFor="let group of element.BudgetsInvolved; let i = index">
                  {{ getDistributionShare(element, i) }}
                </div>
                </div>
              </ng-container>
          
              <ng-template #collapsedDistView>
                <div class="distribution-cell">
                <div *ngFor="let group of element.BudgetsInvolved.slice(0, 2); let i = index">
                 {{ getDistributionShare(element, i) }}
                </div>
                </div>
                <span *ngIf="element.BudgetsInvolved.length > 2">...</span>
              </ng-template>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="DistAmount">
          <th mat-header-cell *matHeaderCellDef>Distribution amount</th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.BudgetsInvolved?.length">
              <ng-container *ngIf="isBudgetCellExpanded(element); else collapsedDistView">
                <div class="distribution-cell">
                <div *ngFor="let group of element.BudgetsInvolved; let i = index">
                  {{ getDistributionAmount(element, i) | number: '1.2' }}
                </div>
                </div>
              </ng-container>
          
              <ng-template #collapsedDistView>
                <div class="distribution-cell">
                <div *ngFor="let group of element.BudgetsInvolved.slice(0, 2); let i = index">
                  {{ getDistributionAmount(element, i) | number: '1.2' }}
                </div>
                </div>
                <span *ngIf="element.BudgetsInvolved.length > 2">...</span>
              </ng-template>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="expand" sticky>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="element.BudgetsInvolved?.length > 2">
              <button mat-icon-button
                      (click)="toggleBudgetCellExpand(element); $event.stopPropagation()"
                      aria-label="Toggle budget details">
                <mat-icon>{{ isBudgetCellExpanded(element) ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplayItemBudgetWithExpand"></tr>
        <tr mat-row *matRowDef="let element; columns: columnsToDisplayItemBudgetWithExpand" class="element-row"
          [class.expanded-row]="isBudgetCellExpanded(element)" tabindex="0"
          (click)="element.BudgetsInvolved?.length > 2 && toggleBudgetCellExpand(element)">
        </tr>
      </table>
    </div>
      <mat-paginator #itemPaginator [pageSize]="defaultPageSize" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons
        class="custom-table-paginator"></mat-paginator>
  </div>
  
  <div class="capital-usage-requirement" *ngIf="capitalUsageRequirmentDataSource.data.length > 0">
    <mat-divider class="divider-gap"></mat-divider>
    <div class="header heading-h6-regular">Capital usage and space requirements</div>
    <!-- <mat-spinner class="mydocs-spinner" *ngIf="isLoadingData && capitalUsageRequirmentDataSource.data.length <= 0"></mat-spinner> -->
    <div class="table-wrapper" *ngIf="capitalUsageRequirmentDataSource.data.length > 0">
      <table mat-table [dataSource]="capitalUsageRequirmentDataSource" multiTemplateDataRows class="mat-elevation-z3 content-table">

        <ng-container matColumnDef="itemno">
          <th mat-header-cell *matHeaderCellDef>Item no.</th>
          <td mat-cell *matCellDef="let element">{{ element.itemno }}</td>
        </ng-container>

        <ng-container matColumnDef="budgetCostCentre">
          <th mat-header-cell *matHeaderCellDef>Capital budget</th>
          <td mat-cell *matCellDef="let element">{{ element.budgetCostCentre }}
          </td>
        </ng-container>

        <ng-container matColumnDef="itemDescription">
          <th mat-header-cell *matHeaderCellDef>Item Description</th>
          <td mat-cell *matCellDef="let element">{{ element.itemDescription }}</td>
        </ng-container>

        <ng-container matColumnDef="itemAmount">
          <th mat-header-cell *matHeaderCellDef>Item amount (SGD).</th>
          <td mat-cell *matCellDef="let element">{{ element.itemAmount}}</td>

        </ng-container>
        <ng-container matColumnDef="estimatedAsset">
          <th mat-header-cell *matHeaderCellDef>Est. usage of asset</th>
          <td mat-cell *matCellDef="let element">{{ element.EstimatedAsset}}</td>

        </ng-container>
        
        <ng-container matColumnDef="IsAdditionalSpaceRequired">
          <th mat-header-cell *matHeaderCellDef>Need add. space?</th>
          <td mat-cell *matCellDef="let element">
            {{ element.IsAdditionalSpaceRequired }}
          </td>
        </ng-container>

        <ng-container matColumnDef="AnnualMaintenanceCost">
          <th mat-header-cell *matHeaderCellDef>Annual main. (SGD)</th>
          <td mat-cell *matCellDef="let element">{{ element.AnnualMaintenanceCost | number: '1.2' }}</td>
        </ng-container>

        <ng-container matColumnDef="IsSupportingNonFundingProject">
          <th mat-header-cell *matHeaderCellDef>Any project not co-fund?</th>
          <td mat-cell *matCellDef="let element">{{ element.IsSupportingNonFundingProject }}</td>
        </ng-container>
        <ng-container matColumnDef="SupportingInformation">
          <th mat-header-cell *matHeaderCellDef>Reasons</th>
          <td mat-cell *matCellDef="let element">{{ element.SupportingInformation }}</td>
        </ng-container>
       
        <tr mat-header-row *matHeaderRowDef="columnsToDisplaCapitalUsageWithExpand"></tr>
        <tr mat-row *matRowDef="let element; columns: columnsToDisplaCapitalUsageWithExpand" class="element-row"
         ></tr>
      </table>
    </div>
  <mat-paginator #capReqPaginator [pageSize]="defaultPageSize" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons
    class="custom-table-paginator"></mat-paginator>
  </div>
  <ng-container
    *ngIf="ApprovingOfficerSummary.purchaseType === PurchaseTypeEnum.TENDER && ApprovingOfficerSummary.PurchaseItemAddOn">
    <mat-divider class="divider-gap" *ngIf="ApprovingOfficerSummary.PurchaseItemAddOn.length > 0"></mat-divider>
    <app-option-purchase-table [dataTb]="ApprovingOfficerSummary.PurchaseItemAddOn || []"></app-option-purchase-table>
  </ng-container>

  <div class="vendors">
    <mat-divider class="divider-gap"></mat-divider>
    <div class="header heading-h6-regular">Vendors</div>
    <div *ngIf="ApprovingOfficerSummary.PDPComplianceItemNumbers" class="mt-3 mb-4 paragraph-medium-regular">
      <shared-alert [type]="alertType.Info">
        <p alert-content class="my-1">Due to Project PDP’s governing factor, these item no. are required to be bought
          from
          ACL/ASL vendors: <strong>{{ApprovingOfficerSummary.PDPComplianceItemNumbers}}</strong></p>
      </shared-alert>
    </div>
    <div class="flex-content paragraph-medium-regular">
      <div class="title">
        Vendors selected
        <span
          *ngIf="!(purchaseDetails.purchaseMode === PurchaseTypeEnum.TENDER || purchaseDetails.purchaseMode === PurchaseTypeEnum.DC)">
          ({{ vendors.length }})
        </span>
        {{ purchaseDetails.purchaseMode === PurchaseTypeEnum.TENDER || purchaseDetails.purchaseMode === PurchaseTypeEnum.DC
        ? ' / ' + 'Justification'
        : '' }}
        <span
          *ngIf="(purchaseDetails.purchaseMode === PurchaseTypeEnum.TENDER || purchaseDetails.purchaseMode === PurchaseTypeEnum.DC)">
          ({{ vendors.length }})
        </span>
      </div>
      <div class="content">
        <div class="flex-vendor-item" *ngFor="let vendor of vendors; let i = index">
          <div [className]="purchaseDetails.purchaseMode === PurchaseTypeEnum.TENDER || purchaseDetails.purchaseMode === PurchaseTypeEnum.DC ? 'overflow-name' : ''">
            {{ i + 1 }}. {{ vendor.Name }}
          </div>
          <div class="overflow-justification" *ngIf="purchaseDetails.purchaseMode ===  PurchaseTypeEnum.TENDER || purchaseDetails.purchaseMode === PurchaseTypeEnum.DC">
            {{ vendor.Justification }}
          </div>
        </div>
      </div>
    </div>
    <!--<div *ngIf="currentWorkflow?.budgetType?.toLowerCase()== 'project'" class="flex-content">
      <div class="title">ACL/ASL requirements:</div>
      <div>
        <a href="" target="_blank" class="black-link">All vendors selected meet Project’s Governing Factors compliance
          for
          use of ACL/ASL vendor.</a>
      </div>
    </div>-->
    <div *ngIf="vendors.length === 1">
      <div class="flex-content paragraph-medium-regular">
        <div class="title">Reason for Waiver of Competition:</div>
        <div class="content woc-vendor">
          {{wocReason?.content}}
        </div>
      </div>
      <div class="flex-content paragraph-medium-regular">
        <div class="title">Waiver of Competition File Reference:</div>
        <div class="content woc-vendor">
          {{fileReference?.Name || '-' }}
        </div>
      </div>
      <div class="flex-content paragraph-medium-regular">
        <div class="title">Justification for Waiver of Competition:</div>
        <div class="overflow-justification">
          {{ApprovingOfficerSummary.WaiverOfCompetition?.WOCJustification}}
        </div>
      </div>
      <div class="flex-content paragraph-medium-regular" *ngIf="purchaseDetails.purchaseMode === PurchaseTypeEnum.DC">
        <div class="title">Reason for DOTP:</div>
        <div class="content woc-vendor" *ngIf="ApprovingOfficerSummary.DOTP">
          {{dotpReason?.Reason}}
        </div>
      </div>
      <div class="flex-content paragraph-medium-regular" *ngIf="purchaseDetails.purchaseMode === PurchaseTypeEnum.DC">
        <div class="title">Remarks :</div>
        <div class="woc-vendor">
          {{ ApprovingOfficerSummary && ApprovingOfficerSummary.DOTP && ApprovingOfficerSummary.DOTP.Remarks ? ApprovingOfficerSummary.DOTP.Remarks : '-' }} 
        </div>
      </div>
      <div class="flex-content paragraph-medium-regular" *ngIf="purchaseDetails.purchaseMode === PurchaseTypeEnum.DC">
        <div class="title">Justification for DOTP :</div>
        <div class="overflow-justification" *ngIf="ApprovingOfficerSummary.DOTP">
          {{ApprovingOfficerSummary.DOTP.DOTPJustification}}
        </div>
      </div>
    </div>
    <!-- <div *ngIf="currentWorkflow?.workflow_id == 'WOCApproval'">
      <div class="flex-content">
        <div class="title">WOC Reason:</div>
        <div class="content woc-vendor">
          {{wocReason?.content}}
        </div>
      </div>
      <div class="flex-content">
        <div class="title">WOC Justification:</div>
        <div class="woc-vendor">
          {{ApprovingOfficerSummary.WaiverOfCompetition?.WOCJustification}}
        </div>
      </div>
      <div class="flex-content">
        <div class="title" *ngIf="ApprovingOfficerSummary.DOTP">WOC-DOTP Reason:</div>
        <div class="content woc-vendor">
          {{dotpReason?.Reason}}
        </div>
      </div>
      <div class="flex-content">
        <div class="title" *ngIf="ApprovingOfficerSummary.DOTP">WOC-DOTP Justification:</div>
        <div class="woc-vendor">
          {{ApprovingOfficerSummary.DOTP.DOTPJustification}}
        </div>
      </div>
  </div> -->
  </div>

  <!-- <div class="section--dirp" *ngIf="isDisplayDIRP()">
    <mat-divider class="divider-gap"></mat-divider>
    <div class="header heading-h6-regular">DIRP Approval</div>
    <p class="text--gray mt-2">This purchase is for a non-R&D project with one-off development cost equals to, or more than S$1M.</p>

    <div class="flex-content">
      <div class="content">
        <div class="flex-vendor-item" *ngFor="let attachment of this.ApprovingOfficerSummary.Attachment">
          <div *ngIf="
              attachment.AttachmentTypeId ===
              AttachmentTypeId.DIRP_APPROVAL
            ">
            <span class="highlight-text" tabindex="0" 
            (keypress)="fileService.downloadAttachment(attachment)" 
            (click)="fileService.downloadAttachment(attachment)">{{ attachment.FileName }}</span>
          </div>

        </div>
      </div>
    </div>
  </div> -->

  <!-- <div class="section--restricted-it-product" *ngIf="isDisplayRestrictedITProduct()">
    <mat-divider class="divider-gap"></mat-divider>
    <div class="header heading-h6-regular">Restricted IT Product Approval</div>
    <ng-container 
      *ngIf="getITProductPolicyNoticeObservable() | async as ITProductPolicyStatusData">
      <ng-container *ngIf="ITProductPolicyStatusData?.data?.DisplayMessage as ITProductPolicyDisplayMessage">
        <div [innerHTML]="ITProductPolicyDisplayMessage | removeNonAscii" class="children--pymy-0 children--underline mt-2"></div>
      </ng-container>
    </ng-container>

    <div class="flex-content paragraph-medium-regular">
      <div class="content">
        <div class="flex-vendor-item" *ngFor="let attachment of this.ApprovingOfficerSummary.Attachment">
          <div *ngIf="
                  attachment.AttachmentTypeId ===
                  AttachmentTypeId.RESTRICTED_IT_PRODUCT_SD || 
                  attachment.AttachmentTypeId === 
                  AttachmentTypeId.RESTRICTED_IT_PRODUCT_SD_CDO
                ">
            <span class="highlight-text" tabindex="0" (keypress)="downloadAttactment(attachment)"
              (click)="downloadAttactment(attachment)">{{ attachment.FileName }}</span>
          </div>
    
        </div>
      </div>
    </div>
  </div> -->

  <!-- <div class="section--approval-covering" *ngIf="purchaseDetails.purchaseMode === PurchaseTypeEnum.PCPO && approvalDocumentAttachment.length > 0">
    <mat-divider class="divider-gap"></mat-divider>
    <div class="header heading-h6-regular">SD / AO approval for permissible covering PO</div>

    <div class="flex-content paragraph-medium-regular">
      <div class="content">
        <div class="flex-vendor-item" *ngFor="let attachment of this.ApprovingOfficerSummary.Attachment">
          <div *ngIf="
              attachment.AttachmentTypeId ===
              AttachmentTypeId.SD_APPROVAL
            ">
            <span class="highlight-text" tabindex="0" 
            (keypress)="fileService.downloadAttachment(attachment)" 
            (click)="fileService.downloadAttachment(attachment)">{{ attachment.FileName }}</span>
          </div>

        </div>
      </div>
    </div>
  </div> -->

  <!-- <div class="vendors" *ngIf="purchaseDetails.purchaseMode === PurchaseTypeEnum.PM">
    <mat-divider class="divider-gap"></mat-divider>
    <div class="header heading-h6-regular">SD Approval</div>

    <div class="flex-content paragraph-medium-regular">
      <div class="content">
        <div class="flex-vendor-item" *ngFor="let attachment of this.ApprovingOfficerSummary.Attachment ">
          <div *ngIf="
              attachment.AttachmentTypeId ===
              AttachmentTypeId.SD_APPROVAL
            ">
            <span class="highlight-text" tabindex="0" (keypress)="fileService.downloadAttachment(attachment)" 
            (click)="fileService.downloadAttachment(attachment)">{{ attachment.FileName }}</span>
          </div>

        </div>
      </div>
    </div>
  </div> -->
<div class="attachments-overview">
  <mat-divider class="divider-gap"></mat-divider>
  <div class="header heading-h6-regular">Attachments</div>
  <ng-container *ngIf="availableDocAttachments.length > 0; else noAttachment">
    <mat-chip-set aria-label="document selection" multiple>
      <mat-chip *ngFor="let attachment of availableAttachments" class="mat-mdc-chip custom-mdc-chip" selectable="true"
        [selected]="isAttachmentSelected(attachment.type)" [class.selected-chip]="isAttachmentSelected(attachment.type)"
        (click)="toggleAttachmentSelection(attachment.type)">
        {{ attachment.label }}
      </mat-chip>
    </mat-chip-set>
    <!-- Attachment Boxes -->
    <ng-container *ngIf="selectedAttachments.size > 0; else noChipSelected">
    <div class="attachment-box" *ngIf="isAttachmentSelected('vendor')">
      <app-scope-of-work [title]="'Document to vendor'" [dataAttachment]="vendorDocumentAttachment"
        [isVendorDocument]="true" [imageUrl]="'/assets/images/vendor-doc-attachment.svg'"></app-scope-of-work>
    </div>

    <div class="attachment-box" *ngIf="isAttachmentSelected('quotation')">
      <app-scope-of-work [title]="'Quotation'" [dataAttachment]="quotationDocumentAttachment"
        [imageUrl]="'/assets/images/quotation-attachment.svg'"></app-scope-of-work>
    </div>

    <div class="attachment-box" *ngIf="isAttachmentSelected('supporting')">
      <app-scope-of-work [title]="'Supporting document'" [dataAttachment]="supportingDocumentAttachment"
        [imageUrl]="'/assets/images/supporting-doc-attachment.svg'"> </app-scope-of-work>
    </div>

    <div class="attachment-box" *ngIf="isAttachmentSelected('approvals')">
      <app-scope-of-work [title]="'Management approval'" [dataAttachment]="approvalDocumentAttachment"
        [imageUrl]="'/assets/images/management-approval-attachment.svg'"></app-scope-of-work>
    </div>

    <div class="attachment-box" *ngIf="isAttachmentSelected('sow')">
      <app-scope-of-work [title]="'Scope Of Work'" [dataAttachment]="scopeOfWorkAttachment"
        [imageUrl]="'/assets/images/scope-of-work-attachment.svg'"></app-scope-of-work>
    </div>

    <div class="attachment-box" *ngIf="isAttachmentSelected('tender')">
      <div class="section-tender-custom">
        <div class="paragraph-large-medium">
          <img src="/assets/images/tender-attachment.svg" alt="Icon" class="tender-doc-icon" />
          Tender document attachments
        </div>
        <div class="tender-date">
          <div class="paragraph-small-regular"><span style="font-weight: 700;">Open Date: </span><span
              style="font-weight: 400;"> {{
              this.ApprovingOfficerSummary.TenderStartDate | date:'dd/MM/yyyy, hh:mm a' }}</span></div>
          <div class="paragraph-small-regular"><span style="font-weight: 700;">Close Date: </span><span
              style="font-weight: 400;">{{
              this.ApprovingOfficerSummary.TenderEndDate | date:'dd/MM/yyyy, hh:mm a' }}</span> </div>
        </div>
        <app-tender-documents [dataAttachment]="tenderDocumentAttachment"></app-tender-documents>
      </div>
    </div>
    </ng-container>

    <ng-template #noChipSelected> <app-add-reference-card desc="Select an option to display attachments.">
    </app-add-reference-card></ng-template>
  </ng-container>
  <ng-template #noAttachment> <app-add-reference-card desc="There is no attachment uploaded.">
    </app-add-reference-card></ng-template>
</div>